import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {LoginService} from './services/login.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {

  public loginError: Error;
  public userName: string;
  public password: string;

  constructor(private router: Router, private loginService: LoginService) { }

  public login(): void {
    this.loginService.login(this.userName, this.password)
      .subscribe(
        (result) => {
          localStorage.clear();
          this.router.navigateByUrl('/');
      },
        (error) => {
          this.loginError = error;
        },
      );
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/login/login.component.ts